export default __webpack_public_path__ + "static/media/icon-coupon.fcacc651.svg";